import React, { Component } from 'react';
import { documentsTitles, saved, remote } from './dynamic_documents';

export class CompanyBankStatement extends Component {
    constructor(props) {
        super(props);
        props.initialconstruct.bind(this)("CompanyBankStatement");
        this.refs = {
            companyBankStatementForm: React.createRef(),
        };
        this.outerclass = "d-flex flex-wrap";
        this.passwordclass = "";
        this.state = {
            banks: Object.values(this.remote('')||{})
        }
    }

    remote(key) {
        return remote(this, key);
    }

    saved(key) {
        return saved(this, key)
    }

    getMonth(date, i) {
        let newDate = new Date(date.getFullYear(), date.getMonth() - i - 1, date.getDate());
        return newDate.getMonthDisplay();
    }

    onTenorChange(tenor, i) {
        if (tenor) {
            let months = [].filllen(tenor).map((o, i) => this.getMonth(new Date(), i))
                .options().map(o => ({ ...o, key: o.key.toLowerCase() }));
            let { banks } = this.state;
            banks[i] = banks[i] || {};
            banks[i].months = months;
            this.setState(() => ({
                banks: [...banks]
            }));
        }
    }

    addBank() {
        let { props } = this;
        let { } = props;
        this.state.banks.push({
            "months": [],
            "bank_name": "Axis Bank",
            "tenor_in_months": 12,
            "type_of_acc": "current",
            "month": "Jan 2022",
            "attachment_id": "attachmentId",
            "filename": "bank_statement_attachment.ext",
            "statement_status": "",
            "sanction_letter_attachment_id": "attachmentId",
            "sanction_letter_filename": "sanction_letter_attachment.ext",
            "sanction_letter_status": ""
        })
        this.setState((state) => ({
            banks: [...this.state.banks]
        }))
    }

    deleteBank(index) {
        let bank = this.state.banks.find((v, i) => i == index)
        // this.setState((state) => ({
        //     banks: [...this.state.banks.filter((v, i) => i != index)]
        // }));
        console.log("bank._id",bank._id,bank);
        this.api.execApi("deleteBankStatement", {}, {
            bank_statement_id: bank._id
        }).then(()=>{

        })
    }

    handleBanks() {
        let banks = Object.values(this.saved() || {});
        banks.map((value, index) => {
            let tenor = +this.saved(`${index}.tenor_in_months.key`);
            this.onTenorChange(tenor, index);
        })
        //let tenor

        if (banks.length == 0) {
            this.addBank();
        }
    }

    getFile(name, offsetkey = "", offsetvalue = "") {
        let { props } = this;
        let { docList: uploaded = {} } = props;
        let mydoclist = uploaded[props.documentKey] ?? [];
        return mydoclist.find(o => o.doc_meta_name.name == name && o.doc_meta_name[offsetkey || "offsetvalue"] == offsetvalue);
    }

    getFileAttrs(subkey, offsetkey = "", offsetvalue = "") {
        let { props } = this;
        let file = this.getFile(subkey, offsetkey, offsetvalue);
        return {
            "data-invalue": file?.attachment_id,
            "data-filename": file?.file_name,
            isuploaded: (!!file),
            labelname: file?.file_name
        }
    }

    uploadDocument(event, name, offsetkey = "", offsetvalue = "") {
        let { props } = this;
        let documentKey = this.props.documentKey;
        let input = event.target;
        let [file] = input.files;
        let docmeta = { name, group: "credit", firmType: props.firmType, documentKey: documentKey, offsetkey, [offsetkey || 'offsetvalue']: offsetvalue };
        let payload = {
            application_id: this.props.urlparams.application_id,
            file,
            doc_meta_name: JSON.stringify(docmeta).encode()
        };
        this.api.execApi("postDocument", payload, {}, {
            multipart: true,
            message: "Uploading please wait...",
            onexec: (response) => {
                success("Upload Successfull").promise.then(() => {
                    this.props.onFetchDocList && this.props.onFetchDocList();
                });
            }
        });
    }

    deleteDocument() {

    }

    downloadDocument() {

    }

    componentDidMount() {
        this.handleBanks();
    }

    setStateValue(key, value) {
        this.store(`credit.state.${this.props.documentKey}.${key}`, value);
    }

    handleDateEvent(date, i, key) {
        let value = date.toDate();
        this.setStateValue(`${i}.${key}`, value);
    }

    handleInputEvent(e, i, key) {
        mixins.debounce(() => {
            this.setStateValue(`${i}.${key}`, e.target.value);
            setTimeout(() => {
                let input = document.querySelector(`[name='${e.target.name}']`);
                input && input.focus();
            }, 0);
        });
    }

    handleSelectEvent([value], i, key) {
        this.setStateValue(`${i}.${key}`, value);
        //this.onTenorChange(value, i)
    }

    storeFilePassword(e, key) {
        mixins.debounce(() => {
            this.store(`credit.state.${this.props.documentKey}.${key}.password`, e.target.value);
        });
    }

    getEditData() {
        let props = this.props;
        let { store } = props;
        let { credit: storeddata = {} } = store;
        return storeddata['remote'] && storeddata['remote'][props.documentKey];
    }

    validateDocuments(payload) {
        let allBankStatements = payload.reduce((flag, o) => (flag && !!o.data.attachment_id), true);
        // let allSactionStatements = payload.reduce((flag,o)=>(flag&&o.type_of_acc=='CC/OD'?!!o.sanction_letter_attachment_id:true),true);
        // console.log({ allBankStatements, allSactionStatements, payload });
        return allBankStatements;
    }

    saveDocInfo() {
        let { props } = this;
        let editData = this.getEditData();
        let { banks } = this.state;
        let data = this.refs.companyBankStatementForm.form.current.getData();
        //let payload = parseInput(data);
        //console.log({payload});
        let payload = parseInput(data).banks.map((bank, i) => ({
            id: bank.bank_statement_id,
            data: {
                "account_number": bank.account_number,
                "bank_name": bank.bank_name,
                "type_of_acc": bank.type_of_acc,
                "start_date": bank.start_date,
                "end_date": bank.end_date,
                "attachment_id": bank.bank_statement,
                "filename": bank.bank_statement_filename,
                ...(bank.bank_statement_filepassword?{"password": bank.bank_statement_filepassword}:{})
            }
        }));
        
        if (this.validateDocuments(payload)) {
            let savedRecords = payload.filter(o=>o.id);
            let newRecords = payload.filter(o=>!o.id);
            let promises = [];
            if (savedRecords.length) {
                console.log({payload});
                let tmppromises = savedRecords.map(o => this.api.execApi("putBankStatement", o.data, {
                    bank_statement_id: o.id
                }));
                promises = promises.concat(tmppromises);
            } 
            if(newRecords.length) {
                let promise = this.api.execApi("postBankStatement", newRecords.map(o => o.data));
                promises.push(promise);
            }
            Promise.all(promises).then(() => {
                alert("Info Updated Successfull.").promise.then(() => {
                    this.props.onInfoList && this.props.onInfoList();
                });
            });
        } else {
            alert("Uoload all documents to proceed further");
        }
    
    }

    render() {
        let { props, state, passwordclass, outerclass } = this;
        let { banks } = state;
        let { documentKey } = props;
        let editData = this.getEditData();
        return (
            <AppForm
                ref="companyBankStatementForm"
                id="companyBankStatementForm"
                onSubmit={() => this.saveDocInfo()}
            >
                {
                    banks.map((bank, i) => (
                        <div key={'key' + i} >
                            {
                                i != 0 && <div className='row'>
                                    <div className='col'></div>
                                    <div className='col-12 col-md-4 flex' onClick={() => this.deleteBank(i)}>
                                        <i className='fa fa-trash ml-auto text-red-500 cursor-pointer'></i>
                                    </div>
                                </div>
                            }
                            <div className='row' >
                                <div className='col-12 col-md-4'>
                                    {
                                        editData && <input 
                                            type='hidden'
                                            name={`banks.${i}.bank_statement_id`}
                                            value={editData[i]?.bank_statement_id} 
                                        />
                                    }
                                    <AppInput
                                        label={documentsTitles[documentKey]["bank_name"]}
                                        onChange={(e) => this.handleSelectEvent(e, i, "bank_name")}
                                        type="select"
                                        name={`banks.${i}.bank_name`}
                                        options={enums.bankNames}
                                        defaultValue={this.saved(`${i}.bank_name.key`)}
                                    />
                                </div>
                                <div className='col-12 col-md-4'>
                                    <AppInput
                                        label={documentsTitles[documentKey]["account_number"]}
                                        type="text"
                                        name={`banks.${i}.account_number`}
                                        onChange={(e) => this.handleInputEvent(e, i, "account_number")}
                                        defaultValue={this.saved(`${i}.account_number`)}
                                    />
                                </div>
                                <div className='col-12 col-md-4'>
                                    <AppInput
                                        label={documentsTitles[documentKey]["start_date"]}
                                        type="date"
                                        name={`banks.${i}.start_date`}
                                        options={enums.Tenor}
                                        onChange={(e) => this.handleDateEvent(e, i, "start_date")}
                                        defaultValue={this.saved(`${i}.start_date`)}
                                    />
                                </div>
                                <div className='col-12 col-md-4'>
                                    <AppInput
                                        label={documentsTitles[documentKey]["end_date"]}
                                        type="date"
                                        name={`banks.${i}.end_date`}
                                        options={enums.Tenor}
                                        onChange={(e) => this.handleDateEvent(e, i, "end_date")}
                                        defaultValue={this.saved(`${i}.end_date`)}
                                    />
                                </div>
                                <div className='col-12 col-md-4'>
                                    <AppInput
                                        label={documentsTitles[documentKey]["type_of_acc"]}
                                        type="select"
                                        name={`banks.${i}.type_of_acc`}
                                        options={enums.AccountTypes}
                                        onChange={(e) => this.handleSelectEvent(e, i, "type_of_acc")}
                                        defaultValue={this.saved(`${i}.type_of_acc.key`)}
                                    />
                                </div>
                                <div className='col-12 col-md-8'>
                                    <AppUploadPassword
                                        label={documentsTitles[documentKey]["bank_statement"]}
                                        name={`banks.${i}.bank_statement`}
                                        passwordclass={passwordclass}
                                        outerclass={outerclass}
                                        haspassword={true}
                                        onChange={(e) => this.uploadDocument(e, "bank_statement", `bank`, i)}
                                        onDelete={(...args) => this.deleteDocument(...args)}
                                        onDownload={(...args) => this.downloadDocument(...args)}
                                        onPasswordChange={(v) => this.storeFilePassword(v, `${i}.bank.bank_statement`)}
                                        password={this.saved(`${i}.bank.bank_statement.password`)}
                                        {...this.getFileAttrs("bank_statement", `bank`, i)}
                                    />
                                </div>
                            </div>
                            <hr />
                        </div>
                    ))
                }
                <div className="row d-flex mb-3 g-3">
                    <div className="col-12">
                        <button className="btn add-btn ml-auto" type="button" onClick={() => this.addBank()}>
                            <i className="fa fa-plus" /> Add Bank
                        </button>
                    </div>
                </div>
                <div className="row d-flex">
                    <div>
                        <button
                            className="btn add-btn text-dark rounded-pill ml-auto"
                        >
                            Update
                        </button>
                    </div>
                </div>
                <hr />
            </AppForm>
        )
    }
}

export default connect(CompanyBankStatement)